import React from "react";
import PropTypes from "prop-types";
import { Menu } from "@fluentui/react-northstar";

const VerticalMenu = (props) => {
  const { items, onMenuItemClick, testId, activeIndex } = props;

  return (
    <Menu
      data-testid={testId}
      defaultActiveIndex={activeIndex}
      items={items}
      vertical
      pointing
      onItemClick={(e, item) => onMenuItemClick(item.index)}
    />
  );
};

VerticalMenu.propTypes = {
  onMenuItemClick: PropTypes.func,
  items: PropTypes.array,
  testId: PropTypes.string,
  activeIndex: PropTypes.number,
};

VerticalMenu.defaultProps = {
  items: [],
  testId: "",
  activeIndex: 0,
};

export default VerticalMenu;
